import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const FieldTextArea = ({ isValid, placeholder, showPlaceholder, name, register }) => {
    return (_jsx("textarea", { id: name, placeholder: placeholder, className: `form-control ${!isValid ? 'is-invalid' : ''} ${showPlaceholder ? 'show-placeholder' : ''}`, rows: 5, ...register }));
};
export default FieldTextArea;
